export default {
  selectLcWorkOrderByPage: '/business/lcWorkOrder/selectLcWorkOrderByPage',
  selectLcPatrolIssueByPages: '/business/lcPatrolIssue/selectLcPatrolIssueByPage',
  selectLcWorkOrderByCount: '/business/lcWorkOrder/selectLcWorkOrderByCount'
}
